export const storage_keys = {
    "authToken": "authToken",
    "userData": "userData",
    "subscription": "subscription",
    "fireBaseToken": "",
    "homeFilter": "homeFilter",
    "galaxyFilter": "galaxyFilter",
    "favoriteFilter": "favoriteFilter",
    "galaxyDetailFilter": "galaxyDetailFilter",
    "frontierList": "frontierList",
    "shiningStarList": "shiningStarList",
    "galaxyList": "galaxyList",
    "galaxyDList": "galaxyDList",
    "pGalaxyList": "pGalaxyList"
}